import { useState } from 'react';

import cx from 'classnames';

import { Alert } from 'components/shared/Alert';
import { DotsSixVertical } from 'components/shared/Icon/phosphorIcons';
import useMediaBreakpoints from 'hooks/useMediaBreakpoints';

import { FontAwesomeIcon } from '../../../../../../shared/Icon/FontAwesome';
import { EventActionMenu } from './EventActionMenu';
import { useEventOption } from './functions';
import s from './index.module.css';
import { IEventOptionProps } from './types';

export const EventOption = ({
  id,
  icon,
  content,
  isDraggable = true,
  isDeletable = true,
  error,
  dragProps,
}: IEventOptionProps) => {
  const [isActionsButtonActive, setIsActionsButtonActive] = useState(false);
  const { handleEdit, handleDelete } = useEventOption({ id });
  const { isMobile } = useMediaBreakpoints();

  return (
    <div className={s.wrapper}>
      <div className={s.event}>
        <div className={s.content}>
          {!isMobile && (
            <div className={s.icon}>
              <FontAwesomeIcon className={icon} />
            </div>
          )}
          <div className={s.eventDetails}>{content}</div>

          <div className={cx(s.actionMenu, isActionsButtonActive && s.active)}>
            {isDraggable && (
              <div ref={dragProps.setActivatorNodeRef} {...dragProps.listeners}>
                <DotsSixVertical weight="bold" className={s.dragButton} size={38} />
              </div>
            )}
            {isDeletable && (
              <EventActionMenu
                onClick={() => setIsActionsButtonActive(!isActionsButtonActive)}
                onEdit={handleEdit}
                onDelete={handleDelete}
              />
            )}
          </div>
        </div>
      </div>
      {error && (
        <div className={s.alertWrapper}>
          <Alert
            className={cx(error.variant === 'danger' && s.alert, error.className)}
            variant={error.variant}
            content={error.content}
          />
        </div>
      )}
    </div>
  );
};
